module.exports = __webpack_public_path__ + "img/version_bgc.511d443d.png";